import { BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { CustomReportResults } from "shared/api/types/pagination";
import { SocietyProfileReportInputParams } from "shared/api/types/society/[societyId]/profiles/[profileId]/reports/[reportId]";
import { CustomReportResponseType } from "shared/api/types/society/[societyId]/reports/[reportId]";
export const getSocietyProfileReportIdContract: BaseApiContract<
  SocietyProfileReportInputParams,
  undefined,
  CustomReportResults<CustomReportResponseType>
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/reports/[reportId]",
  paramsType: {} as SocietyProfileReportInputParams,
  responseType: undefined as unknown as CustomReportResults<CustomReportResponseType>,
};
